import Feedback from "../../../classes/Feedback";
import { db } from "../../../boot/firebase";
import { call } from "../../../util/misc";
import { ORIGIN } from "../../../constants";
import { router } from "../../../router";
import asyncPool from "tiny-async-pool";
import {
  collection,
  deleteDoc,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";

export const GET_FEEDBACK = async ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: Feedback,
    path: Feedback.getPath(id),
    stateKey: "feedback",
    id,
  });
};

export const SUBMIT_CUSTOMER_FEEDBACK = async (context, { id, data }) => {
  return call("submitCustomerFeedback", { id, data });
};

export const LISTEN_FEEDBACK = (
  { dispatch },
  { pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Feedback,
    path: Feedback.getPath(),
    // conditions: ["sent", "!=", null],
    stateKey: "feedback",
    pagination,
    next,
    error,
    unlisten,
  });
};

export const REQUEST_FEEDBACK = async (
  { dispatch },
  { company, recipients, subject, message }
) => {
  const MAX_CONCURRENT = 3;
  const existing = [];
  const errors = [];
  const successes = [];
  const feedbackCollection = collection(db, Feedback.getPath()).withConverter(
    Feedback
  );

  await asyncPool(MAX_CONCURRENT, recipients, async (recipient) => {
    let feedbackRef;
    let existingSnapshots = await feedbackCollection
      .where("contactID", "==", recipient.contact)
      .get();
    if (existingSnapshots.empty) {
      feedbackRef = doc(feedbackCollection);
    } else {
      if (existingSnapshots.docs[0].data().sent) {
        existing.push(recipient);
        return;
      } else {
        feedbackRef = existingSnapshots.docs[0].ref;
      }
    }

    let feedback = new Feedback(feedbackRef.id, {
      contactID: recipient.contact,
      sentTo: recipient.email,
      company,
    });
    try {
      await setDoc(feedbackRef, feedback);
    } catch (error) {
      errors.push({ error, recipient });
      return;
    }

    let url =
      ORIGIN +
      router.resolve({
        name: "customer-feedback",
        params: { feedbackID: feedbackRef.id },
      }).fullPath;

    try {
      await dispatch("SEND_EMAIL", {
        to: recipient.email.address,
        subject,
        message: message + `<br/><br/><a href="${url}">${url}</a>`,
      });
      successes.push(recipient);
      let sent = new Date();
      await updateDoc(feedbackRef, { sent });
    } catch (error) {
      errors.push({ error, recipient });
    }
  });

  return { existing, errors, successes };
};

export const DELETE_FEEDBACK = async ({ commit }, id) => {
  await deleteDoc(doc(db, Feedback.getPath(id)));
  commit("REMOVE", { stateKey: "feedback", id });
};
